module.exports = __webpack_public_path__ + "static/media/lese-is-wrong.38d387ac.mp3";